module.exports = "/templates/bds/public/font/586bdc7d039fe13bda883d81bc822a0e.eot";